/* eslint-disable no-restricted-syntax */
/* eslint-disable no-unused-vars */
import actions from 'redux-auto'
import i18n from 'i18next'
import {findNestedValue} from 'ag-common/tools/objects'
import Api from '#services/api'

export function pending(state, payload) {
  return {
    ...state,
    isSaving: true,
    errorSavingAnswer: undefined,
    queue: state.queue.filter(i => i.timestamp !== payload.timestamp),
  }
}

export function fulfilled(state, payload, result) {
  const kommentar = findNestedValue(state, ['answers', result.kapitelId, result.frageId, 'kommentar'])
  const existingKapitelAnswers = state.answers[result.kapitelId]
  const existingQuestionAnswers = existingKapitelAnswers ? state.answers[result.kapitelId][result.frageId] : {}
  const newState = {
    ...state,
    isSaving: false,
    answers: {
      ...state.answers,
      [result.kapitelId]: {
        ...(existingKapitelAnswers || {}),
        [result.frageId]: {
          ...existingQuestionAnswers,
          ...result,
          kommentar,
        },
      },
    },
  }
  addChapterIfNotExists(newState, result.kapitelId)

  const chapterOfAnswer = newState.answers[result.kapitelId]
  let finishedAnswersCount = 0
  for (const answer in chapterOfAnswer) {
    if (chapterOfAnswer[answer] && chapterOfAnswer[answer].done === true) {
      finishedAnswersCount += 1
    }
  }
  chapterOfAnswer.finishedAnswersCount = finishedAnswersCount

  return newState
}

const addChapterIfNotExists = (newState, kapitelId) => {
  if (!newState.answers[kapitelId]) {
    newState.answers[kapitelId] = {}
  }
}

export function rejected(state) {
  return {
    ...state,
    isSaving: false,
    errorSavingAnswer: i18n.t('misc_saving_error'),
  }
}

export async function action(payload) {
  try {
    return await Api.postAnswer(payload.chapterId, payload.questionId, payload.answer, payload.done, payload.antwortTyp)
  } catch (e) {
    actions.error.writeError({error: e})
    throw new Error(i18n.t(e.message))
  }
}
